import { render, staticRenderFns } from "./ChangeLogDialog.vue?vue&type=template&id=4b0c8cf8&scoped=true"
import script from "./ChangeLogDialog.vue?vue&type=script&lang=js"
export * from "./ChangeLogDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogDialog.vue?vue&type=style&index=0&id=4b0c8cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c8cf8",
  null
  
)

export default component.exports